import { FC } from "react";
import Icon from ".";
import { IconElementProps, createIconVariantMap } from "./Icon.types";

export const Filled12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6ZM10.5 6C10.5 8.21359 8.9017 10.0539 6.79618 10.4298C6.56927 10.4703 6.45582 10.4906 6.32969 10.4449C6.23042 10.4089 6.12 10.3164 6.06715 10.225C6 10.1089 6 9.9726 6 9.7V2.3C6 2.0274 6 1.8911 6.06715 1.77497C6.12 1.68356 6.23042 1.59111 6.32969 1.55514C6.45582 1.50945 6.56927 1.5297 6.79618 1.57021C8.9017 1.94612 10.5 3.78641 10.5 6Z" fill="currentColor" />
    </svg>
  );
};

export const Filled16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.666626 8.00033C0.666626 3.95024 3.94987 0.666992 7.99996 0.666992C12.05 0.666992 15.3333 3.95024 15.3333 8.00033C15.3333 12.0504 12.05 15.3337 7.99996 15.3337C3.94987 15.3337 0.666626 12.0504 0.666626 8.00033ZM14 8.00033C14 10.9518 11.8689 13.4055 9.06153 13.9067C8.75899 13.9607 8.60772 13.9877 8.43955 13.9268C8.30718 13.8788 8.15996 13.7556 8.08949 13.6337C7.99996 13.4789 7.99996 13.2971 7.99996 12.9337V3.06699C7.99996 2.70352 7.99996 2.52179 8.08949 2.36695C8.15996 2.24507 8.30718 2.1218 8.43955 2.07385C8.60772 2.01292 8.75899 2.03993 9.06153 2.09394C11.8689 2.59515 14 5.04887 14 8.00033Z" fill="currentColor" />
    </svg>
  );
};

export const Filled20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.833374 9.99967C0.833374 4.93706 4.93743 0.833008 10 0.833008C15.0627 0.833008 19.1667 4.93706 19.1667 9.99967C19.1667 15.0623 15.0627 19.1663 10 19.1663C4.93743 19.1663 0.833374 15.0623 0.833374 9.99967ZM17.5 9.99967C17.5 13.689 14.8362 16.7561 11.327 17.3827C10.9488 17.4502 10.7597 17.4839 10.5495 17.4078C10.3841 17.3478 10.2 17.1937 10.112 17.0414C10 16.8478 10 16.6207 10 16.1663V3.83301C10 3.37867 10 3.1515 10.112 2.95795C10.2 2.8056 10.3841 2.65152 10.5495 2.59158C10.7597 2.51542 10.9488 2.54918 11.327 2.6167C14.8362 3.2432 17.5 6.31035 17.5 9.99967Z" fill="currentColor" />
    </svg>
  );
};

export const Outlined12 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16197)">
        <path d="M10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5C8.48528 10.5 10.5 8.48528 10.5 6ZM8.75 6C8.75 4.652 7.78001 3.53107 6.5 3.2959V8.70361C7.77997 8.46841 8.75 7.34797 8.75 6ZM9.75 6C9.75 8.07107 8.07107 9.75 6 9.75C5.72386 9.75 5.5 9.52614 5.5 9.25V2.75C5.5 2.47386 5.72386 2.25 6 2.25C8.07107 2.25 9.75 3.92893 9.75 6ZM11.5 6C11.5 9.03757 9.03757 11.5 6 11.5C2.96243 11.5 0.5 9.03757 0.5 6C0.5 2.96243 2.96243 0.5 6 0.5C9.03757 0.5 11.5 2.96243 11.5 6Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16197">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined16 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16195)">
        <path d="M14 8.00033C14 4.68662 11.3137 2.00033 7.99996 2.00033C4.68625 2.00033 1.99996 4.68662 1.99996 8.00033C1.99996 11.314 4.68625 14.0003 7.99996 14.0003C11.3137 14.0003 14 11.314 14 8.00033ZM11.6666 8.00033C11.6666 6.20299 10.3733 4.70841 8.66663 4.39486V11.6051C10.3732 11.2915 11.6666 9.79762 11.6666 8.00033ZM13 8.00033C13 10.7618 10.7614 13.0003 7.99996 13.0003C7.63177 13.0003 7.33329 12.7018 7.33329 12.3337V3.66699C7.33329 3.2988 7.63177 3.00033 7.99996 3.00033C10.7614 3.00033 13 5.2389 13 8.00033ZM15.3333 8.00033C15.3333 12.0504 12.05 15.3337 7.99996 15.3337C3.94987 15.3337 0.666626 12.0504 0.666626 8.00033C0.666626 3.95024 3.94987 0.666992 7.99996 0.666992C12.05 0.666992 15.3333 3.95024 15.3333 8.00033Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16195">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Outlined20 = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_6165_16193)">
        <path d="M17.5 9.99967C17.5 5.85754 14.1422 2.49967 10 2.49967C5.85791 2.49967 2.50004 5.85754 2.50004 9.99967C2.50004 14.1418 5.85791 17.4997 10 17.4997C14.1422 17.4997 17.5 14.1418 17.5 9.99967ZM14.5834 9.99967C14.5834 7.75301 12.9667 5.88478 10.8334 5.49284V14.5057C12.9667 14.1137 14.5834 12.2463 14.5834 9.99967ZM16.25 9.99967C16.25 13.4515 13.4518 16.2497 10 16.2497C9.5398 16.2497 9.16671 15.8766 9.16671 15.4163V4.58301C9.16671 4.12277 9.5398 3.74967 10 3.74967C13.4518 3.74967 16.25 6.54789 16.25 9.99967ZM19.1667 9.99967C19.1667 15.0623 15.0627 19.1663 10 19.1663C4.93743 19.1663 0.833374 15.0623 0.833374 9.99967C0.833374 4.93706 4.93743 0.833008 10 0.833008C15.0627 0.833008 19.1667 4.93706 19.1667 9.99967Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_6165_16193">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const variants = createIconVariantMap({
  filled: {
    12: Filled12,
    16: Filled16,
    20: Filled20,
  },
  outlined: {
    12: Outlined12,
    16: Outlined16,
    20: Outlined20,
  },
});

export const IconContrast02: FC<IconElementProps & { className?: string }> = (props) => (
  <Icon name={"contrast-02"} {...props} />
);
